import TechStack from './TechStack'

export default TechStack
